import React, {useCallback, useContext, useEffect, useState} from 'react';
import { push } from 'connected-react-router';
import { useDispatch } from 'react-redux';
import { useHistory, useRouteMatch } from 'react-router';

import ModalPreventForm from './ModalPreventForm';
import { checkChangeResource, getPreventLeaveText } from './utils';
import { DeferredActionContext } from '../../services/common/DeferredActionContext';

type Props = {
  preventCancelChanges: boolean;
};

export const PreventChangeRouteModal = ({ preventCancelChanges }: Props) => {
  const dispatch = useDispatch();
  const { clearActions, processActions } = useContext(DeferredActionContext);

  const [redirectOpen, setRedirectOpen] = useState(false);
  const [nextRoute, setNextRoute] = useState('');
  const redirectTexts = getPreventLeaveText();
  const { block } = useHistory();
  const { url } = useRouteMatch();

  const cancelRedirectHandler = useCallback(() => {
    setRedirectOpen((prev) => !prev);
    dispatch(push(nextRoute));
    processActions();
  }, [setRedirectOpen, nextRoute, dispatch, processActions]);

  const approveRedirectHandler = useCallback(() => {
    setRedirectOpen((prev) => !prev);
    clearActions();
  }, [setRedirectOpen, clearActions]);

  useEffect(() => {
    const unregister = block((e) => {
      if (!redirectOpen && preventCancelChanges && checkChangeResource(url, e.pathname)) {
        setNextRoute(e.pathname);
        setRedirectOpen(true);
        return false;
      }
    });

    return () => unregister();
  }, [setRedirectOpen, setNextRoute, block, url, preventCancelChanges, redirectOpen]);
  // end redirect modal

  return (
    <ModalPreventForm
      open={redirectOpen}
      cancelHandler={cancelRedirectHandler}
      approveHandler={approveRedirectHandler}
      onEscapeKeyDown={() => { setTimeout(() => { approveRedirectHandler(); }, 250); }}
      title={redirectTexts.title}
      message={redirectTexts.message}
      approveText={redirectTexts.approveText}
      cancelText={redirectTexts.cancelText}
    />
  );
};

export default PreventChangeRouteModal;
